import instance from "./axios.config";

const addFormConfiguration = (payload) =>
    instance.post("/forms/form-configurations", payload);

const getAllFormconfiguration = () =>
    instance.get(`/forms/form-configurations`);


const updateformConfiguration = (id, payload) =>
    instance.put(`/forms/form-configurations/${id}`, payload);

const deleteformConfiguration = (id) =>
    instance.put(`/forms/delete-form-configurations/${id}`);


const syncFormConfiguration = (payload) =>
    instance.post(`/forms/sync-form-configurations`,payload);




const formCreationService = {
    addFormConfiguration,
    getAllFormconfiguration,
    updateformConfiguration,
    deleteformConfiguration,syncFormConfiguration
}
export default formCreationService;
